




















































































































import {
  getQueryString,
  setQueryString
} from "@/common/assets/js/utils/queryParams";
import { getThanksOrGrantTypeLabel, getApprovalStatusLabel } from "@/common/assets/js/utils/types";
import ButtonRefine from "@/common/components/atoms/ButtonRefine.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import FormSearch from "@/common/components/atoms/FormSearch.vue";
import PageNavi from "@/common/components/atoms/PageNavi.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import commons from "@/common/store/modules/commons";
import H01PointConfirmItem from "@/general/components/pages/parts/PointHistoryList/H01PointConfirmItem.vue";
import TheH01Notification from "@/general/components/pages/parts/PointHistoryList/TheH01Notification.vue";
import TheH01ProfilePanel from "@/general/components/pages/parts/PointHistoryList/TheH01ProfilePanel.vue";
import { getPointHistoryList } from "@/general/store/api";
import { Transaction, UserInfo } from "@/general/store/models";
import globals from "@/general/store/modules/globals";
import { Component, Vue } from "vue-property-decorator";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import { checkLengthInput } from "@/general/utils/helper";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheHeader,
    TheFooter,
    CommonHeading,
    PageNavi,
    ButtonRefine,
    H01PointConfirmItem,
    TheH01ProfilePanel,
    TheH01Notification,
    FormSearch,
    TheBreadcrumb,
    ValidationErrorText
  }
})
export default class PointConfirmation extends Vue {
  searchResultCount: number | undefined = 0;
  searchEvent: string | undefined = "";
  heading = "";
  historyList: Array<any> = [];
  refine: any = {
    target: " ",
    shownState: false,
    itemList: [
      {
        id: "refine-invested",
        value: "invested",
        label: "付与"
      },
      {
        id: "refine-give",
        value: "give",
        label: "贈与"
      },
      {
        id: "refine-gived",
        value: "gived",
        label: "受贈"
      },
      {
        id: "refine-use",
        value: "use",
        label: "利用"
      },
      {
        id: "refine-all",
        value: "all",
        label: "全て"
      }
    ]
  };
  sorted: any = {
    target: "-created_at",
    shownState: false,
    itemList: [
      {
        id: "sorted-asc",
        value: "created_at",
        label: "日付 (昇順)"
      },
      {
        id: "sorted-desc",
        value: "-created_at",
        label: "日付 (降順)"
      },
      {
        id: "points-asc",
        value: "points",
        label: "ポイント（昇順）"
      },
      {
        id: "points-desc",
        value: "-points",
        label: "ポイント（降順）"
      }
    ]
  };
  search = "";
  error = "";
  $refs!: {
    theHeader: TheHeader;
  };
  get refineHeading() {
    if (this.refine.target) {
      for (let i = 0; i < this.refine.itemList.length; i++) {
        if (this.refine.itemList[i].value === this.refine.target) {
          return this.refine.itemList[i].label;
        }
      }
    }
    return "絞り込み";
  }
  get filterHeading() {
    return "並び替え";
  }
  get unit() {
    return commons?.unit;
  }
  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }
  get approvedEnabled() {
    // const orgAdminSettings = JSON.parse(
    //   LocalStorage.getItem("orgAdminSettings") as string
    // );
    // return orgAdminSettings[0].thanks_point_approval_enabled ? true : false;

    const userDetails = LocalStorage.getItem("userDetails");
    // ローカル対応：userDetailsデータがない場合を考慮する
    if (userDetails && userDetails !== '""') {
      const userDetailsJson = JSON.parse(userDetails);
      return userDetailsJson.thanks_point_approval_enabled;
    }
    return null;
  }
  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }
  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }
  get isGroupBudget() {
    return commons.userInfo.groupBudgetMode;
  }
  get computedItemList() {
    if (this.isGroupBudget) {
      // isGroupBudgetがtrueの場合の項目
      return [
        { id: "refine-all-gb", value: "all", label: "全て" },
        { id: "refine-use", value: "use", label: "利用" },
        { id: "refine-invested", value: "invested", label: "付与" }
      ];
    } else {
      return this.refine.itemList;
    }
  }

  async setPageData() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const redirect_from = urlParams.get("redirect_from")
      ? (urlParams.get("redirect_from") as string)
      : undefined;
    let breadcrumb: any = [];
    if (redirect_from != undefined && redirect_from == "my-page") {
      breadcrumb = [
        {
          text: "",
          url: CONST_DATA.SITE_MAP.TOP_PAGE,
          pageType: "home"
        },
        {
          text: "マイページ",
          url: CONST_DATA.SITE_MAP.MY_PAGE,
          pageType: "lower"
        },
        {
          text: " ポイント確認",
          url: "",
          pageType: "lower"
        }
      ];
    } else {
      breadcrumb = [
        {
          text: "",
          url: CONST_DATA.SITE_MAP.TOP_PAGE,
          pageType: "home"
        },
        {
          text: " ポイント確認",
          url: "",
          pageType: "lower"
        }
      ];
    }
    await commons.getBreadcrumb(breadcrumb);
  }
  baseUrl = CONST_DATA.SITE_MAP.POINT_CONFIRMATION;
  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: ""
  };
  setPageNav(count: number) {
    const maxPage =
      count % this.pageSize >= 1
        ? Math.floor(count / this.pageSize) + 1
        : count / this.pageSize;
    const { params } = this;
    params.page = parseInt(params.page + "", 10);
    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = params.page;
    this.pageNavi.baseUrl =
      this.baseUrl + "?" + getQueryString({ ...params, page: undefined });
    this.pageNavi.nextPageUrl =
      this.baseUrl + "?" + getQueryString({ ...params, page: params.page + 1 });
    this.pageNavi.prevPageUrl =
      this.baseUrl + "?" + getQueryString({ ...params, page: params.page - 1 });
  }
  params = {
    transaction_type: "",
    transaction_direction: "",
    filter_position: "",
    refine_position: "",
    ordering: "",
    page: 1,
    pageSize: this.pageSize,
    search: "",
    isRefined: false
  };

  async created() {
    AuthStorage.checkLogin();
    const KEY = "APPLY_CART_ITEMS_APPLICATION_COMPLETE";
    const cartDone = sessionStorage.getItem(KEY);
    if (typeof cartDone === "string" && cartDone === "Done") {
      sessionStorage.setItem(KEY, "Complete");
    }
    const queries = [
      { k: "transaction_type" },
      { k: "transaction_direction" },
      { k: "filter_position" },
      { k: "refine_position" },
      { k: "ordering", v: "-created_at" },
      { k: "page", v: 1 },
      { k: "search" }
    ];
    this.params = setQueryString(this.params, queries);
    await commons.setOrgPageSpecificDataFromLocalStorage();
    await this.setPageData();
    this.search = this.params.search;
    this.setSort();
    this.setRefine();
    // TheHeader.vueから呼ぶユーザー情報が遅いので履歴を標示する前にとりあえずユーザー情報を取得するAPIを呼ぶ
      const response = await getPointHistoryList(
      this.params.ordering,
      this.params.page,
      this.pageSize,
      this.params.search,
      this.params.transaction_type,
      this.params.transaction_direction
    );
    this.setHistoryList(response.results || []);
    this.setPageNav(response.count as number);
    
    const urlParams = new URLSearchParams(window.location.search);
    this.params.isRefined = urlParams.get('isRefined') === 'true';

    if (this.historyList.length == 0 && !this.params.search && !this.params.isRefined) {
      setTimeout(function(){
        window.location.href = "/no-point-confirmation-history-found/";
      }, 4*1000);
    }    
    if (this.historyList.length == 0 && this.params.search && this.params.search !== "") {
      window.location.href =
        "/point-confirmation-history-search/?" + getQueryString(this.params);
    }
  }
  setHistoryList(historyList: Array<Transaction>) {
    if (historyList.length > 0) {
      const list: Array<any> = [];
      historyList.forEach((res: any) => {
        const {
          pk,
          points,
          transaction_details,
          transaction_type,
          user_id
        } = res;
        if (transaction_type === 10) {
          // Use - Redeem
          const all_redemption_details =
            transaction_details?.redemption_details;
          all_redemption_details?.forEach((redemption_details: any) => {
            list.push({
              name: transaction_details.menu_name,
              icon: redemption_details?.plan_image_url,
              unread: false,
              group: "",
              group_code: "",
              shipping_status: false,
              point_status: {
                // point: redemption_details?.use_point, //TODO waiting product domain
                point: points,
                point_addition: false,
                usage: "user",
                usage_label: "利用",
                annotation_label: "", // 配布専用
                annotation_type: "",
                approved: getApprovalStatusLabel(transaction_details?.status)
                // approved: ""
              },
              date: this.$dayjs
                .utc(transaction_details.applied_date)
                .format("YYYY/MM/DD"),
              url: `/point-confirmation-history-usage/?${getQueryString({
                ...this.params,
                id: pk
              })}`,
              icon_type: 0
            });
          });
        } else if (
          transaction_type === 20 ||
          transaction_type === 40 ||
          transaction_type === 80 ||
          transaction_type === 90 ||
          transaction_type === 100
        ) {
          // Grant Points - 20: NoLimit - 30:ThanksOnly - 40:GrantOnly
          const { from_user, to_user, grant_criteria } = transaction_details;
          const pointAddition =
            user_id === from_user && user_id !== to_user ? false : true;
          // DX_IC-942
          list.push({
            name: transaction_details.title,
            icon: transaction_details.icon_id,
            unread: false,
            group: "",
            group_code: "",
            shipping_status: false,
            point_status: {
              point: transaction_details.points,
              point_addition: pointAddition,
              usage: "invested",
              usage_label: "付与",
              annotation_label:
                transaction_details.grant_type !== 10
                  ? getThanksOrGrantTypeLabel(transaction_details.grant_type)
                  : "",
              annotation_type: grant_criteria?.kind,
              approved: getApprovalStatusLabel(transaction_details?.status)
              // approved: ""
            },
            date: this.$dayjs
              .utc(transaction_details.authorize_date)
              .format("YYYY/MM/DD"),
            url: `${CONST_DATA.SITE_MAP.DETAILS_GRANT_POINTS}?${getQueryString({
              id: pk,
              ...this.params
            })}`,
            icon_type: 1
          });
        } else if (transaction_type === 50) {
          // User-to-User : Thanks Giving or Thanks Receiving
          const { from_user, to_user } = transaction_details;

          if (from_user?.id === user_id) { // 贈与
            // Giving
            const user = to_user;
            list.push({
              name: user.user_name,
              icon: user.user_image,
              unread: false,
              group: user.group_name,
              group_code: user.group_code,
              // shipping_status: false,
              point_status: {
                point: points,
                point_addition: false,
                usage: "give",
                usage_label: "贈与",
                annotation_label: "",
                annotation_type: "",
                // approved: transaction_details.approved_or_rejected_at
                //   ? "承認済み"
                //   : "承認待ち"
                approved: transaction_details?.status === "approved" ? "" : getApprovalStatusLabel(transaction_details?.status)
              },
              date: this.$dayjs
                .utc(
                  transaction_details?.status === "approved"
                    ? transaction_details?.approved_or_rejected_at
                    : transaction_details?.created_at
                )
                .format("YYYY/MM/DD"),
              url: `${
                CONST_DATA.SITE_MAP.DETAILS_GRANT_THANKS
              }?${getQueryString({ id: pk, ...this.params })}`,
              icon_type: 0
            });
          } else if (to_user?.id === user_id) { //受贈
            // Receiving
            // DX_IC-942
            const user = from_user;
            list.push({
              name: user.id == 0 ? "－" : user.user_name,
              icon: user.id == 0 ? "" : user.user_image,
              unread: false,
              group: user.id == 0 ? "－" : user.group_name,
              group_code: user.id == 0 ? "" : user.group_code,
              // shipping_status: false,
              point_status: {
                point: points,
                point_addition: true,
                usage: "gived",
                usage_label: "受贈",
                annotation_label: "",
                annotation_type: "",
                // approved: transaction_details.approved_or_rejected_at
                //   ? "承認済み"
                //   : ""
                approved: transaction_details?.status === "approved" ? "" : getApprovalStatusLabel(transaction_details?.status)
              },
              date: this.$dayjs
                .utc(transaction_details?.approved_or_rejected_at)
                .format("YYYY/MM/DD"),
              url: `${
                CONST_DATA.SITE_MAP.DETAILS_GRANT_THANKS
              }?${getQueryString({ id: pk, ...this.params })}`,
              icon_type: 0
            });
          }
          // return {};
        } else if (transaction_type === 60) {
          // Group Admin to User (distribution)
          list.push({
            name: "DIS-TODO",
            icon: "",
            unread: false,
            group: "",
            group_code: "",
            shipping_status: false,
            point_status: {
              point: points,
              point_addition: true,
              usage: "invested",
              usage_label: "付与",
              annotation_label: "", // 配布専用
              annotation_type: "distribution",
              // approved: ""
              approved: getApprovalStatusLabel(transaction_details?.status)
            },
            date: "2019/01/01",
            url: `${CONST_DATA.SITE_MAP.DETAILS_GRANT_POINTS}?${getQueryString({
              id: pk,
              ...this.params
            })}`,
            icon_type: 0
          });
        //GroupBudgetの内容に従って付与と利用を追加する
        // } else if ("付与") {
        //   list.push({
        //   })
        // } else if ("利用") {
        //   list.push({
        //   })
        }
      });
      this.historyList = list;
    }
  }
  doSearch() {
    const checkValidLength = checkLengthInput(this.search, 50);
    if (!checkValidLength?.isValid) {
      this.error = checkValidLength?.error;
      return false;
    }
    this.params.search = this.search;
    this.params.page = 1;
    window.location.href = this.baseUrl + "?" + getQueryString(this.params);
  }
  setSort() {
    if (this.params.ordering) {
      this.sorted.target = this.params.ordering;
    }
  }
  doSort($event: any) {
    this.params.ordering = $event;
    window.location.href = this.baseUrl + "?" + getQueryString(this.params);
  }
  setRefine() {
    if (this.params.transaction_type === "0") {
      this.refine.target = "all";
    } else if (this.params.transaction_type === "10") {
      this.refine.target = "use";
    } else if (this.params.transaction_type === "20") {
      this.refine.target = "invested";
    } else if (this.params.transaction_type === "50") {
      if (this.params.transaction_direction === "losing") {
        this.refine.target = "give";
      } else if (this.params.transaction_direction === "gaining") {
        this.refine.target = "gived";
      }
    }

    // サンクス設定がない場合は絞り込み条件で「受贈」「贈与」を非表示にする
    if (this.approvedEnabled !== null && !this.approvedEnabled) {
      this.refine.itemList = this.refine.itemList.filter(
        (item: any) => item.value !== "give" && item.value !== "gived"
      );
    }
  }
  doRefine($event: string) {
    if ($event === "all") {
      this.params.transaction_type = "0";
      this.params.transaction_direction = "";
      this.params.isRefined = false
    } else if ($event === "invested") {
      this.params.transaction_type = "20";
      this.params.transaction_direction = "";
      this.params.isRefined = true
    } else if ($event === "give") {
      this.params.transaction_type = "50";
      this.params.transaction_direction = "losing";
      this.params.isRefined = true
    } else if ($event === "gived") {
      this.params.transaction_type = "50";
      this.params.transaction_direction = "gaining";
      this.params.isRefined = true
    } else if ($event === "use") {
      this.params.transaction_type = "10";
      this.params.transaction_direction = "";
      this.params.isRefined = true
    // API実装後にgroupbudget側のtransactiontypeなどを修正する
    // } else if ($event === "use-gb") {
    //   this.params.transaction_type = "10";
    //   this.params.transaction_direction = "";
    //   this.params.isRefined = true
    // } else if ($event === "invested-gb") {
    //   this.params.transaction_type = "20";
    //   this.params.transaction_direction = "";
    //   this.params.isRefined = true
    }
    this.params.page = 1;
    window.location.href = this.baseUrl + "?" + getQueryString(this.params);
  }

  get errorMessage() {
    if (this.historyList.length === 0 && this.params.isRefined) {
      return "ご指定の検索条件に該当するポイント履歴が見つかりませんでした。";
    }
    return "";
  }

  switchRefineState(value: boolean) {
    this.refine.shownState = value;
  }
  switchSortedState(value: boolean) {
    this.sorted.shownState = value;
  }
}
